import styled from "styled-components";
import {FlexContainer} from "../../BaseComponents/Flex";
import media from "styled-media-query";
import breakpoints from "Framework/helpers/BreakpointHelper/BreakpointHelper";

export const SideMenuWrapper = styled(FlexContainer).attrs(
	({ smallpadding, smallflexdirection, autoWidth }) => ({
		smallPadding: smallpadding ? smallpadding : "1rem",
		smallDirection: smallflexdirection ? smallflexdirection : "",
	})
)`
	& {
		display: flex;
		flex-direction: column;
		padding-top: 10px;
		float: right;
		max-width: 330px;
		width: ${(props) => props.width};
		/* flex-direction: ${(props) => props.flexDirection}; */
		padding: ${(props) => props.padding};
		${media.lessThan(breakpoints.ipad)`
		padding: ${(props) => props.smallPadding};

		display:none;
    
    `}
	}
`;
